import { apiSlice } from "./apiSlice";
import {
  GET_SAVED_ITEMS_URL,
  ADD_SAVED_ITEM_URL,
  REMOVE_SAVED_ITEM_URL,
} from "../constants";

export const savedItemsApi = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchSavedItems: builder.query({
      query: ({ page = 1, limit = 10 }) => ({
        url: `${GET_SAVED_ITEMS_URL}?page=${page}&limit=${limit}`,
        method: "GET",
      }),
    }),

    addSavedItem: builder.mutation({
      query: (data) => ({
        url: ADD_SAVED_ITEM_URL,
        method: "POST",
        body: data, // Send { productId }
      }),
    }),
    removeSavedItem: builder.mutation({
      query: (data) => ({
        url: REMOVE_SAVED_ITEM_URL,
        method: "POST",
        body: data, // Send { productId }
      }),
    }),
  }),
});

export const {
  useFetchSavedItemsQuery,
  useAddSavedItemMutation,
  useRemoveSavedItemMutation,
} = savedItemsApi;
